<div class="d-flex justify-content-between align-items-center p-3 border-bottom border-light shadow-sm pb-0">
  <h2 class="modal-title mb-0 ms-2 fw-bold">Horario asignado para {{ data.nombreEmpleado }}</h2>
  <button mat-dialog-close mat-icon-button><mat-icon>close</mat-icon></button>
</div>
<div [ngClass]="{'m-3': data.diaIncidencia}">
  <app-horario-detalle [soloConsulta]="true" [horario]="data.horario" [diaIncidencia]="data.diaIncidencia" [horarioEmpleado]="true"></app-horario-detalle>
</div>
